import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};
const SvgLogoOfNoah = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      height={40}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 447.13 102.37"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      color={color}
      {...props}
    >
      <path d="M21.98 81.64C4.85 77.04-3.48 61.55 1.37 43.47c4.85-18.05 19.79-27.34 36.95-22.73 17.13 4.6 25.46 20.09 20.61 38.17-4.85 18.08-19.79 27.34-36.95 22.73Zm15-55.98c-13.78-3.7-25.29 3.89-29.46 19.47-4.17 15.55 2.01 27.88 15.79 31.58 13.78 3.7 25.29-3.89 29.46-19.47 4.17-15.55-2.01-27.88-15.79-31.58ZM68.7 81.56V20.81h40.21v5.12H74.69v22.54h27.2v5.12h-27.2v27.96H68.7ZM260.18 32.5c-4.01 0-8.74 2.89-10.5 5.49v-5.05H235.4v48.62h14.28V54.8c0-2.81.71-4.93 2.18-6.46 1.47-1.53 3.43-2.25 6.03-2.25 3.33 0 5.43.83 6.41 2.55 1.14 1.99 1.71 5.46 1.71 10.35v22.57h14.28V56.14c0-7.7-1.68-13.6-5.01-17.56-3.4-4.03-8.48-6.08-15.12-6.08ZM312.27 32.5c-6.98 0-13 2.44-17.88 7.26-4.88 4.82-7.37 10.79-7.37 17.71s2.49 12.83 7.41 17.71c4.92 4.88 10.92 7.36 17.84 7.36s12.93-2.47 17.84-7.36c4.91-4.89 7.41-10.84 7.41-17.71s-2.48-12.88-7.37-17.71c-4.89-4.83-10.9-7.26-17.88-7.26Zm8.64 33.59c-2.48 2.48-5.3 3.69-8.64 3.69s-6.16-1.21-8.64-3.69c-2.48-2.48-3.67-5.3-3.67-8.61s1.2-6.13 3.68-8.61c2.48-2.48 5.3-3.69 8.64-3.69s6.16 1.21 8.64 3.69c2.48 2.48 3.68 5.3 3.68 8.61s-1.21 6.13-3.69 8.61ZM379.42 37.31c-1.35-2.91-7.25-4.81-11.38-4.81-7.01 0-13.04 2.44-17.92 7.27-4.88 4.83-7.36 10.79-7.36 17.71s2.5 12.83 7.41 17.71c4.92 4.88 10.92 7.36 17.84 7.36 0 0 7.57 0 11.39-5.37v4.37h14.28V32.93H379.4v4.38Zm-2.76 28.77c-2.48 2.48-5.31 3.69-8.63 3.69s-6.16-1.21-8.64-3.69c-2.48-2.48-3.68-5.3-3.68-8.61s1.2-6.13 3.68-8.61c2.48-2.48 5.3-3.69 8.64-3.69s6.16 1.21 8.63 3.69c2.48 2.48 3.68 5.3 3.68 8.61s-1.2 6.13-3.68 8.61ZM442.13 38.58c-3.39-4.04-8.48-6.08-15.12-6.08-4.01 0-7.52.86-10.5 2.56V11.2h-14.28v70.35h14.28V54.79c0-2.81.71-4.93 2.19-6.46 1.48-1.53 3.43-2.25 6.03-2.25 3.33 0 5.43.83 6.41 2.55 1.14 1.99 1.72 5.46 1.72 10.35v22.57h14.28V56.13c0-7.69-1.68-13.6-5.01-17.56Z" />
      <path
        style={{
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 10
        }}
        d="M172.16 0v102.37"
      />
    </svg>
  );
};
export default SvgLogoOfNoah;
